// extracted by mini-css-extract-plugin
export default {"magicFlagTooltip":"MagicFlagsIndicator_magicFlagTooltip__lYN7M","magicFlagIcon":"MagicFlagsIndicator_magicFlagIcon__gRobo"};